import FormControlLabel from "@mui/material/FormControlLabel";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import {
  saveConnorsLandingPrefs,
  shouldSkipConnorsAgeGate,
} from "../../shared/ConnorsApplyConfirm/connorsStorage";
import {
  AgeGateButton,
  ButtonRow,
  CheckboxRow,
  CollectiveTitle,
  ConfirmationText,
  ContentContainer,
  DisclaimerText,
  LogoImage,
  OverlayBackground,
  WhiteCheckbox,
} from "./styles";

function ConnorsAgeGate({ children }) {
  const router = useRouter();
  const [showAgeGate, setShowAgeGate] = useState(true);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  useEffect(() => {
    if (shouldSkipConnorsAgeGate()) {
      setShowAgeGate(false);
    }
  }, []);

  const handleYes = () => {
    if (doNotShowAgain) {
      saveConnorsLandingPrefs();
    }
    setShowAgeGate(false);
  };

  const handleNo = () => {
    router.push("/jobs");
  };

  return (
    <Fragment>
      {showAgeGate ? (
        <OverlayBackground data-testid="connors-age-gate-overlay">
          <ContentContainer>
            <LogoImage
              src="https://assets.wobbjobs.com/images/connors-logo.png"
              alt="Connor's Stout Porter"
            />

            <CollectiveTitle>Collective</CollectiveTitle>

            <ConfirmationText>
              I CONFIRM THAT I AM NON-MUSLIM
              <br />
              AND AGED 21 YEARS OLD AND ABOVE
            </ConfirmationText>

            <ButtonRow>
              <AgeGateButton
                type="button"
                onClick={handleNo}
                data-testid="connors-age-gate-no"
              >
                No, I am not
              </AgeGateButton>
              <AgeGateButton
                type="button"
                onClick={handleYes}
                data-testid="connors-age-gate-yes"
              >
                Yes, I am
              </AgeGateButton>
            </ButtonRow>

            <CheckboxRow>
              <FormControlLabel
                control={
                  <WhiteCheckbox
                    checked={doNotShowAgain}
                    onChange={(event) =>
                      setDoNotShowAgain(event.target.checked)
                    }
                    inputProps={{
                      "data-testid": "connors-age-gate-dont-show",
                    }}
                  />
                }
                label="Do not show again"
                sx={{
                  margin: 0,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.875rem",
                    color: "rgba(255, 255, 255, 0.85)",
                    paddingTop: "5px",
                    fontFamily:
                      '"Hops and Barley C4", "Helvetica Neue", Helvetica, Arial, sans-serif',
                  },
                }}
              />
            </CheckboxRow>
          </ContentContainer>

          <DisclaimerText>
            PLEASE SHARE THIS SITE ONLY WITH INDIVIDUALS AGED 21+ AND THOSE WHO
            ARE NON-MUSLIMS. IF YOU DRINK, DON&apos;T DRIVE.
            <br />
            <b>#CELEBRATE</b>RESPONSIBLY
            <br />
            <br />
            CARLSBERG MARKETING SDN BHD 198501008089 (140534-M) NO. 55,
            PERSIARAN SELANGOR, SEKSYEN 15, 40200 SHAH ALAM, SELANGOR, MALAYSIA.
          </DisclaimerText>
        </OverlayBackground>
      ) : null}
      {!showAgeGate ? children : null}
    </Fragment>
  );
}

export default ConnorsAgeGate;
